import { render, staticRenderFns } from "./PriceDashboard.vue?vue&type=template&id=719159a5"
import script from "./PriceDashboard.vue?vue&type=script&lang=js"
export * from "./PriceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports